<template>
  <div>
    <Header :title="$t('loan.title')" />
    <div
      class="full-page-box"
      style="background-color: rgb(248 249 250); min-height: calc(100vh)"
    >
      <div class="loan-box-tile">
        <p>{{ $t("loan.msg1") }}</p>
        <p>{{ $t("loan.msg2") }}</p>
        <p v-if="lst && lst.length > 0">{{ $t("loan.msg3", { day: getMonth(lst[0].timeStart) }) }}</p>
        <p v-else>{{ $t("loan.msg31") }}</p>
        <img
          v-if="!(lst && lst.length > 0)"
          src="../../assets/imgs/loan/loan.jpg"
          style="width: 60%"
        />
        <van-button
          v-if="!(lst && lst.length > 0)"
          block
          class="btn"
          @click="topage('home')"
          >{{ $t("loan.btn") }}</van-button
        >
      </div>
      <div class="loan-box-desc" v-if="lst && lst.length > 0">
        {{ $t("loan.msg4") }}
      </div>
      <div v-if="lst && lst.length > 0">
        <div class="loan-box-item" v-for="(item, index) in lst" :key="index">
          <van-row>
            <van-col :span="12">{{ $t("loan.money") }}</van-col>
            <van-col :span="12" class="text-right"
              >{{ formatNumberWithCommas(item.price) }} {{ $t("common.unit") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loan.cycle") }}</van-col>
            <van-col :span="12" class="text-right"
              >{{ item.term }} {{ $t("common.month") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loan.stime") }}</van-col>
            <van-col :span="12" class="text-right">
              {{ item.timeStart }}
            </van-col>
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loan.etime") }}</van-col>
            <van-col
              :span="12"
              class="text-right"
              style="color: rgb(254 127 45)"
            >
          {{ item.timeEnd }}
          </van-col>
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">
              <p>{{ $t("loan.everyissue") }}</p>
              ({{ $t("loan.everyissuedesc") }})
            </van-col>
            <van-col :span="12" class="text-right" style="font-weight: 700"
              >{{ formatNumberWithCommas(item.monthlyPayment) }} {{ $t("common.unit") }}</van-col
            >
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loan.bank") }}</van-col>
            <van-col :span="12" class="text-right">{{ item.bank }}</van-col>
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12">{{ $t("loan.status") }}</van-col>
            <van-col
              :span="12"
              class="text-right"
              style="color: rgb(45 205 241)"
            >
              {{ toStatus(item.status) }}
            </van-col>
          </van-row>
          <van-divider
            :dashed="true"
            :style="{ borderColor: 'rgb(254 127 45)' }"
          />
          <van-row>
            <van-col :span="12"></van-col>
            <van-col :span="12" class="text-right" style="color: rgb(4 109 181)"
              ><span @click="toinfo(item.id)"
                >{{ $t("loan.info") }}<van-icon name="arrow" /></span
            ></van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {  Toast } from "vant";
import Header from "@/components/header/index.vue";
import { formatNumberWithCommas } from "@/utils/validate";
export default {
  name: "MyLoan",
  components: { Header },
  data() {
    return {
      lst: [],
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
    } else {
      this.getlst()
    }
  },
  methods: {
    getMonth(val){
      const d = new Date(val)
      return d.getDate()
    },
    formatNumberWithCommas(val){
      return formatNumberWithCommas(val)
    },
    toStatus(val) {
      let reuslt = val;
      switch (val) {
        case 1:
          reuslt = this.$t("loan.Waiting");
          break;
        case 2:
          reuslt = this.$t("loan.Loaninprogress");
          break;
        case 3:
          reuslt = this.$t("loan.Loanalreadymade");
          break;
        case 4:
          reuslt = this.$t("loan.Rejected");
          break;
        default:
          break;
      }
      return reuslt;
    },
    topage(val) {
      this.$router.push({ name: val });
    },
    toinfo(val) {
      this.$router.push({ name: "loaninfo", query: { oid: val } });
    },
    getlst() {
      this.$http({
        method: "get",
        url: "getloan",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.lst = res.data
          }
        } else {
          Toast(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.loan-box-tile {
  width: 96%;
  margin: 20px auto;
  border-radius: 8px;
  background-color: #fff;
  padding: 15px;
  line-height: 2;
  text-align: center;
}
.loan-box-tile > p:nth-child(2n - 1) {
  color: rgb(4 109 181);
}
.loan-box-desc {
  font-weight: 700;
  text-align: center;
}
.loan-box-item {
  width: 96%;
  margin: 15px auto;
  border-radius: 8px;
  background-color: #fff;
  padding: 15px 10px;
}
.text-right {
  text-align: right;
}
.btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181);
  color: #fff;
  border-radius: 8px;
}
</style>
